import { render, staticRenderFns } from "./update-note-modal.vue?vue&type=template&id=3420308c&scoped=true"
import script from "./update-note-modal.vue?vue&type=script&lang=js"
export * from "./update-note-modal.vue?vue&type=script&lang=js"
import style0 from "./update-note-modal.vue?vue&type=style&index=0&id=3420308c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3420308c",
  null
  
)

export default component.exports